import { ICondition } from '../../../../vendor_core/core/src/states/State';
import VendorModel from '../../../../vendor_core/server/model/VendorModel';

export default class BBShouldExitFreeGamesCondition implements ICondition {
    check(): boolean {
        let isInFreeGames =
            VendorModel.inFreeGames &&
            VendorModel.freeGames != null &&
            VendorModel.freeGames != undefined;

        return (
            isInFreeGames && VendorModel.freeGames.spins === 0
            // (VendorModel.freeGames.spins === 0 || freeGamesExpired)
        );
    }
}
